import img from "../../images/media.png";
import "../../style/carouselPerView.css";
import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader } from "../../components/ui/card";
import pdfImg from "../../images/icons/pdf.png";
import { getAllPaginatedSupports } from "../../API/Mediatheque/Support/supportService";

const MediathequeSupportCommunication = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({
    totalPages: 0,
    count: 0,
    supports: [],
  });

  const fetchData = async () => {
    setLoading(true);
    const response = await getAllPaginatedSupports(currentPage);
    if (response) {
      const { supports, totalPages, count } = response;
      setData({
        ...data,
        supports: supports,
        totalPages,
        count,
      });
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const openFile = (file: any) => {
    const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
    const fileUrl = `${uploadUrl}/medias/support/${encodeURIComponent(file)}`;

    window.open(fileUrl, "_blank");
  };
  return (
    <div className=" mb-52">
      <div className="">
        <section
          className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
            {"Médiathèque"}
          </h1>

          <div className="flex justify-center mt-3">
            <p className="w-full text-white ">
              {"Toutes nos documentations à votre disposition"}
            </p>
          </div>
        </section>
      </div>

      <div className="">
        <h1 className="p-5 mt-20 text-4xl font-bold text-center text-black uppercase">
          SUPPORTS DE COMMUNICATION
        </h1>

        <div className="container mt-20">
          <div className="justify-center space-y-5 md:space-x-24 md:flex md:space-y-0">
            {data.supports.map((file: any) => (
              <Card
                className="cursor-pointer border-primary bg-neutral-100"
                key={file.id}
                onClick={() => file.file && openFile(file.file)}
              >
                <CardHeader className="items-center p-10 text-center ">
                  {/* <FaFilePdf className="w-12 h-12" /> */}
                  <img src={pdfImg} alt="" />
                </CardHeader>
                <CardContent className="font-bold text-center text-black ">
                  {file.title}{" "}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {data.totalPages > 1 && (
          <div className="flex justify-center mt-6 space-x-2">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              className={`px-4 py-2 rounded ${
                currentPage === 1
                  ? "bg-gray-300"
                  : "bg-primary text-white hover:bg-primary-dark"
              }`}
            >
              Précédent
            </button>
            <span className="px-4 py-2 border rounded">
              {currentPage} / {data.totalPages}
            </span>
            <button
              disabled={currentPage === data.totalPages}
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, data.totalPages))
              }
              className={`px-4 py-2 rounded ${
                currentPage === data.totalPages
                  ? "bg-gray-300"
                  : "bg-primary text-white hover:bg-primary-dark"
              }`}
            >
              Suivant
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MediathequeSupportCommunication;
